import manifest from "./destinationPolicyManifest.json";

export const connectorSealingAssetName = `3b-connector-seal-${manifest.policyId}.mjs`;
